import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/Alajuela.svg";
import { CAMPAIGN_2021 } from '../../../../constants';

const stateName = "Alajuela";
const stateId = "drdqUqE7Bmq76jJH63Go";

const Alajuela = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2021" campaign={CAMPAIGN_2021}>
      <StateIcon />
    </State>
  );
};

export default Alajuela;
